/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetProjectsRequest, TGetProjectsModel, IMappers, TGetProjectsResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IProjectsGetResponse } from '../../entities/projects/ProjectsGetResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetProjectsModel(parameters: IGetProjectsRequest): TGetProjectsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'promotions-flow-control',
    pathApi: '/v1/get-projects/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetProjectsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetProjectsRequest;
}

export async function fetchGetProjects<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetProjectsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetProjectsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetProjectsModel(parameters),
    config,
  )) as FetchResponse<TGetProjectsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IProjectsGetResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetProjectsResponse>;
}
